import { Outlet, Navigate } from 'react-router-dom'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import FlagsPanel from '../components/FlagsPanel'
import './LayoutPage.css'

function LayoutPage() {
  const [flagsVisible, setFlagsVisible] = useState(false)
  const loggedIn = useSelector(state=>state.user.loginState === 1)
  if (!loggedIn) return <Navigate to="/login" replace />
  return (
    <div>
      <Outlet />
      {flagsVisible?(<div className='flag-box'>
        <div className='flag-box-pannel'>
          <FlagsPanel />
          <button className='flag-close-btn' onClick={()=>{setFlagsVisible(false)}}>Close</button>
        </div>
      </div>):null}
      <button className='flag-menu' onClick={()=>{setFlagsVisible(!flagsVisible)}}>FLAG</button>
    </div>
  )
}

export default LayoutPage